module.exports = __webpack_public_path__ + "assets/img/pierre-cote-113px.2e680257.png";